import { render, staticRenderFns } from "./PendingReceiveList.vue?vue&type=template&id=2518336c"
import script from "./PendingReceiveList.vue?vue&type=script&lang=js"
export * from "./PendingReceiveList.vue?vue&type=script&lang=js"
import style0 from "./PendingReceiveList.vue?vue&type=style&index=0&id=2518336c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2518336c')) {
      api.createRecord('2518336c', component.options)
    } else {
      api.reload('2518336c', component.options)
    }
    module.hot.accept("./PendingReceiveList.vue?vue&type=template&id=2518336c", function () {
      api.rerender('2518336c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/pending-receive/views/PendingReceiveList.vue"
export default component.exports